module.exports = __webpack_public_path__ + "img/124ne.2e8b16d2.svg";